import React from 'react';
import { useTranslation } from 'react-i18next';
import { Filter } from 'iconsax-react';
import TitleText from '@/components/atoms/TitleText';
import InfoText from '@/components/atoms/InfoText';
import Button from '@/components/atoms/Button';
import Search from '@/components/categories/Search';
import { LOGISTICS_FEEDBACK_SEARCH_KEY } from '@/hooks/useLogisticsFeedback';

interface LogisticsFeedbackFiltersProps {
  onFilterClick: () => void;
  'data-testid'?: string;
}

export const LogisticsFeedbackFilters: React.FC<
  LogisticsFeedbackFiltersProps
> = ({
  onFilterClick,
  'data-testid': dataTestId = 'logistics-feedback-card-header',
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 p-6 pb-0"
      data-testid={dataTestId}
    >
      <div
        className="flex flex-col gap-1"
        data-testid="logistics-feedback-title-wrapper"
      >
        <TitleText
          text={t('logisticsFeedback.feedbacksTitle')}
          className="!text-2xl !font-bold text-light-text-primary dark:text-dark-text-primary leading-none"
          data-testid="logistics-feedback-card-title"
        />
        <InfoText
          text={t('logisticsFeedback.feedbacksSubtitle')}
          className="!text-sm !font-normal text-[#637381] dark:text-dark-text-secondary !leading-none"
          data-testid="logistics-feedback-card-desc"
        />
      </div>

      <div
        className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full md:w-auto"
        data-testid="logistics-feedback-card-actions"
      >
        <Search
          searchName={LOGISTICS_FEEDBACK_SEARCH_KEY}
          inputWidth="!w-[330px] !h-[46px] !p-3 !gap-2 !rounded !border !border-light-input-border dark:!border-dark-input-border opacity-100"
          data-testid="logistics-feedback-search-input"
        />
        <Button
          size="md"
          onClick={onFilterClick}
          className="!rounded !h-[46px] !border-light-input-border dark:!border-dark-input-border !px-4 !py-0 !gap-2.5 !bg-white dark:!bg-dark-surface-primary !text-light-text-primary dark:!text-dark-text-primary whitespace-nowrap w-full sm:w-auto justify-center items-center [&>span]:flex [&>span]:items-center [&>span]:leading-none"
          variant="outline"
          icon={
            <Filter
              size={18}
              variant="Outline"
              className="block shrink-0 text-light-text-primary dark:text-dark-text-primary"
            />
          }
          data-testid="logistics-feedback-filter-btn"
        >
          {t('logisticsFeedback.filterButton')}
        </Button>
      </div>
    </div>
  );
};
